import { render } from "./LogisticTableDeclorant.vue?vue&type=template&id=e43a5902"
import script from "./LogisticTableDeclorant.vue?vue&type=script&lang=js"
export * from "./LogisticTableDeclorant.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__